import { IRecognitionAchievement } from 'types/income';
import { convertUploadedFile } from 'store/files';
import { loaders } from './recognition-achievements.loaders';
import { RecognitionAchievement } from './recognition-achievements.types';

const convertAchievement = (
  achievement: IRecognitionAchievement,
): RecognitionAchievement => {
  return {
    id: achievement.id,
    name: achievement.name,
    status: achievement.status,
    isActive: achievement.isActive,
    startDate: achievement.startDate ?? null,
    endDate: achievement.endDate ?? null,
    points: achievement.points,
    limit: achievement.limit,
    limitPeriod: achievement.limitPeriod,
    image: achievement.image ? convertUploadedFile(achievement.image) : null,
    requiresApproval: achievement.requiresApproval,
    priorityIndex: achievement.priorityIndex,
    employeeGroups: achievement.employeeGroups ?? [],
    translations: achievement.translations,
  };
};

const convertAchievements = (
  achievements: IRecognitionAchievement[],
): RecognitionAchievement[] => {
  return achievements.map(convertAchievement);
};

export const converters = {
  getAchievement: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getAchievement>>) => {
    return convertAchievement(data);
  },
  getAchievements: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getAchievements>>) => {
    return convertAchievements(data);
  },
};
